/**
 * Production Line Helper Functions
 * Utilities for production line workflow logic
 */

/**
 * Dashboard tab: row highlight when the order's permanent rack field is set.
 * Uses only `order.rack` (not temporary_rack).
 */
export function orderHasDashboardRackFilled(order: { rack?: string | null }): boolean {
  const r = order.rack;
  return typeof r === 'string' && r.trim() !== '';
}

/**
 * Dashboard Complete: all orders in the job must have permanent rack filled.
 * Temporary rack does not count (aligns with orderHasDashboardRackFilled / row green state).
 */
export function allOrdersHaveRack(
  orders: Array<{ job_id: string; rack?: string | null }>,
  currentJobId: string
): boolean {
  const jobOrders = orders.filter((order) => order.job_id === currentJobId);

  if (jobOrders.length === 0) {
    return false;
  }

  return jobOrders.every((order) => orderHasDashboardRackFilled(order));
}

/** Job refs ready for dashboard Complete / bulk complete — same rules as OrderTableRow complete_button + allOrdersHaveRack */
export function getDashboardJobsReadyForComplete(
  orders: Array<{
    job_id: string;
    website_job_number?: string | null;
    is_first_order_from_job?: boolean;
  }>
): Array<{ id: string; website_job_number?: string | null }> {
  const result: Array<{ id: string; website_job_number?: string | null }> = [];
  const seen = new Set<string>();
  for (const order of orders) {
    if (!order.is_first_order_from_job) continue;
    const jid = order.job_id;
    if (seen.has(jid)) continue;
    if (!allOrdersHaveRack(orders, jid)) continue;
    seen.add(jid);
    result.push({
      id: jid,
      website_job_number: order.website_job_number ?? null,
    });
  }
  return result;
}
